import VmpCard from './src/main';
import VmpCardPreview from './src/preview';
import VmpCardPreviewWap from './src/previewWap';

/* istanbul ignore next */
const components = [VmpCard, VmpCardPreview, VmpCardPreviewWap];

const install = function (Vue, opts = {}) {
  components.forEach(component => {
    Vue.component(component.name, component);
  });
};

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}

export default { VmpCard, VmpCardPreview, VmpCardPreviewWap };
